import { render, staticRenderFns } from "./CompanyTypeAttribute.vue?vue&type=template&id=33afd762&"
import script from "./CompanyTypeAttribute.vue?vue&type=script&lang=js&"
export * from "./CompanyTypeAttribute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports